import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { RefreshCw, Loader2 } from 'lucide-react';
import axios from '../config/axios';

const StripeRefresh = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Automatically try to get a new onboarding link
    const refreshLink = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          setStatus('not_logged_in');
          return;
        }

        console.log('[STRIPE REFRESH] Getting new account link...');
        
        const response = await axios.post('/api/monetization/stripe/create-account-link', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log('[STRIPE REFRESH] Response:', response.data);

        if (response.data.success && response.data.url) {
          // Redirect to the new Stripe onboarding link
          window.location.href = response.data.url;
        } else {
          setStatus('error');
          setError(response.data.error || 'Failed to create new link');
        }
      } catch (err) {
        console.error('[STRIPE REFRESH] Error:', err);
        setStatus('error');
        setError(err.response?.data?.error || err.message || 'An error occurred');
      }
    };

    refreshLink();
  }, []);

  const handleRetry = () => {
    setStatus('loading');
    setError(null);
    window.location.reload();
  };

  const handleGoToDashboard = () => {
    navigate('/reviewer-dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-gray-800 border-gray-700">
        <CardHeader className="text-center">
          <CardTitle className="text-white text-2xl">Stripe Setup</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {status === 'loading' && (
            <div className="text-center py-8">
              <Loader2 className="w-16 h-16 text-yellow-500 animate-spin mx-auto mb-4" />
              <p className="text-gray-300">Refreshing your setup link...</p>
              <p className="text-gray-500 text-sm mt-2">You&apos;ll be redirected to Stripe shortly.</p>
            </div>
          )}

          {status === 'error' && (
            <div className="text-center py-8">
              <RefreshCw className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">Link Expired</h3>
              <p className="text-gray-300 mb-2">
                We couldn&apos;t refresh your Stripe setup link.
              </p>
              {error && (
                <p className="text-red-400 text-sm mb-6">{error}</p>
              )}
              <div className="space-y-3">
                <Button onClick={handleRetry} className="w-full bg-yellow-500 text-black hover:bg-yellow-600">
                  Try Again
                </Button>
                <Button onClick={handleGoToDashboard} variant="outline" className="w-full">
                  Go to Dashboard
                </Button>
              </div>
            </div>
          )}

          {status === 'not_logged_in' && (
            <div className="text-center py-8">
              <RefreshCw className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">Please Log In</h3>
              <p className="text-gray-300 mb-6">
                You need to be logged in to continue Stripe setup.
              </p>
              <Button onClick={() => navigate('/login')} className="bg-yellow-500 text-black hover:bg-yellow-600">
                Go to Login
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default StripeRefresh;
